// Dates and times as Swedish documents write them: 2026-11-20, 08:00, 2026-11-20 08:00.
const dateFmt = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Stockholm',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});
const timeFmt = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Stockholm',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
const weekdayFmt = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Stockholm',
  weekday: 'long',
  day: 'numeric',
  month: 'long',
});
const shortDayFmt = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Stockholm',
  weekday: 'short',
  day: 'numeric',
  month: 'numeric',
});
const numFmt = new Intl.NumberFormat('sv-SE');
const moneyFmt = new Intl.NumberFormat('sv-SE', {
  style: 'currency',
  currency: 'SEK',
  maximumFractionDigits: 0,
});

export const day = (iso: string) => dateFmt.format(new Date(iso));
export const clock = (iso: string) => timeFmt.format(new Date(iso)).replace(/^24/, '00');
export const moment = (iso: string) => `${day(iso)} ${clock(iso)}`;
export const weekday = (iso: string) =>
  weekdayFmt.format(new Date(iso.length === 10 ? `${iso}T12:00:00` : iso));
export const shortDay = (iso: string) =>
  shortDayFmt.format(new Date(iso.length === 10 ? `${iso}T12:00:00` : iso));
export const span = (from: string, to: string) =>
  day(from) === day(to)
    ? `${day(from)} ${clock(from)} till ${clock(to)}`
    : `${moment(from)} till ${moment(to)}`;
export const num = (n: number) => numFmt.format(n);
export const kr = (n: number) => moneyFmt.format(n);
export const km = (n: number) => `${numFmt.format(n)} km`;
export const plate = (p: string) => (p.length === 6 ? `${p.slice(0, 3)} ${p.slice(3)}` : p);
export const vehicleName = (v: {
  registrationNumber: string;
  make: string | null;
  model: string | null;
}) => `${[v.make, v.model].filter(Boolean).join(' ')} ${plate(v.registrationNumber)}`.trim();
/** Today in Sweden as YYYY-MM-DD. */
export const todayIso = () => dateFmt.format(new Date());
export const stockholmDate = (iso: string) => dateFmt.format(new Date(iso));
export const stockholmTime = (iso: string) => clock(iso);
